import swiper from "./swiper";
import lazyload from "./lazyload";
import tailwindConfig from "../../tailwind.config.js";


(function () {
	const mediaQuery = "(max-width: " + (parseInt(tailwindConfig.theme.screens.md, 10) - 1) + "px)";
	const mediaQueryList = window.matchMedia(mediaQuery);
	let swiperContainer = document.querySelector(".swiper-container");
	
	////////// Initialize Image Lazy Load
	
	lazyload.init();

	////////// Initialize Swiper

	if(document.body.contains(swiperContainer)){
		initSwiper(mediaQueryList);

		try {
			// Chrome & Firefox
			mediaQueryList.addEventListener("change", function(event) {
				initSwiper(event);
			})
		} catch (e1) {
			try {
				// Safari
				mediaQueryList.addListener((e) => {
					initSwiper(e);
				});
			} catch (e2) {
				console.error(e2);
			}
		}
	}

	function initSwiper(mqList) {

		if (mqList.matches) {
			swiper.init();
		} else {
			if(swiperContainer.classList.contains("swiper-container-initialized")) {
				swiper.disable();
			}
		}
	}
})();